<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";
import Menu from '@/pages/products/_menu.vue'

export default {
  mixins: [Datatable],
  components: {Link, App, Card, Menu},
  props: ['product'],
  data() {
    return {
      product: this.product,
    }
  },
}
</script>

<template>
  <App title="Onderhoudshistorie">
    <Menu :product-id="this.product.id" />

    <template #topButtons>
      <Link :href="route('products.maintenance_histories.create', {'product': product})" class="btn btn-primary">
        <i class="bi bi-plus-lg"></i>
          Onderhoudshistorie toevoegen
      </Link>
    </template>

    <Card>
      <Table ref="table" id="maintenance_histories" :config="tableConfig"/>
    </Card>
  </App>
</template>